export const rewardTypes = {
  data: [
    {
      displayText: 'Bonus Products',
      value: 'bonus_products',
    },
    {
      displayText: 'Cash',
      value: 'cash',
    },
    {
      displayText: 'Digital',
      value: 'digital',
    },
    {
      displayText: 'Digital Pre-order',
      value: 'digital_pre_order',
    },
    {
      displayText: 'Discount',
      value: 'discount',
    },
    {
      displayText: 'Loyalty',
      value: 'loyalty',
    },
    {
      displayText: 'PepVoucher Discount',
      value: 'pepvoucher_discount',
    },
    {
      displayText: 'PepVoucher Product',
      value: 'pepvoucher_product',
    },
    {
      displayText: 'Physical',
      value: 'physical',
    },
    {
      displayText: 'Product',
      value: 'product',
    },
    {
      displayText: 'Visa',
      value: 'visa',
    },
  ],
}

export const rewardSegments = {
  data: [],
}

export const bonusProducts = {
  data: [],
} 